var UserType = /*#__PURE__*/function (UserType) {
  UserType[UserType["Mobile"] = 0] = "Mobile";
  UserType[UserType["Fttb"] = 1] = "Fttb";
  UserType[UserType["Convergent"] = 2] = "Convergent";
  return UserType;
}(UserType || {});
export { UserType };